import React, { ReactElement } from 'react';
import Button from 'atomic/button';

import './adult-container.scss';
import Icon from 'atomic/icon';

const AdultContainer: React.FC<{ agree: () => void; disagree: () => void; }> = ({ agree, disagree }): ReactElement => (
    <div className="adult-container">
        <div className="adult">
            <div className="container">
                <div className="adult-icon">
                    <Icon name="erotyka" size={20} />
                </div>
                <div className="adult-main">
                    <div className="adult-main__text">
                        <span>
                            Treści znajdujące się na tej stronie są przeznaczone dla osób pełnoletnich.
                        </span>
                    </div>
                </div>
                <div className="adult-footer">
                    <div className="adult-footer__text">
                        <span>
                            Czy masz ukończone 18 lat?
                        </span>
                    </div>
                    <div className="adult-footer__button">
                        <Button color="primary" onClick={agree}>
                            Tak
                        </Button>
                        <Button color="primary" onClick={disagree}>
                            Nie
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default AdultContainer;
